import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { RootStoreContext } from "../app/stores/rootStore";
import Loader from "../components/common/Loader";
import DocumentPinPage from "../components/guest/DocumentPinPage";
import GuestBrowsePage from "../views/GuestBrowsePage";

import { toast } from "react-toastify";

interface IGuestLayoutParams {
  zone: string;
}

const GuestLayout: React.FC<RouteComponentProps<IGuestLayoutParams>> = ({
  match,
  history,
  location
}) => {
  const rootStore = useContext(RootStoreContext);
  const {
    isNativeApp,
    isOnline,
    isOfflineModeEnabled,
  } = rootStore.commonStore;
  const { loadPresentation, showPresentationPage ,loadGuestByCodeZone, getThemeGuest,guestUsername} = rootStore.guestStore;
  const [loaded, setLoaded] = useState(false);
  const urlParams = new URLSearchParams(location.search);
  const zone = urlParams.get("code") ?? "";
  console.log("GuestLayout")
  useEffect(() => {
    if (isNativeApp && (!isOnline || isOfflineModeEnabled)){
    history.push("/offline");
    }else {
      if(zone){
        
        loadGuestByCodeZone(zone).then(
          (dto) => { 
            if(dto) 
             loadPresentation().then(
            (dto)=> { if(dto) getThemeGuest(dto.guestTheme)}
             ).catch().finally(() => setLoaded(true))
             else
             loadPresentation(true).then(
              (dto)=> { if(dto) getThemeGuest(dto.guestTheme)}
               ).catch().finally(() => setLoaded(true))
           }
        ).catch();
      } else {
      
        loadPresentation().finally(() => setLoaded(true));
      }
 //  loadPresentation().finally(() => setLoaded(true))
     
    };
  }, [isNativeApp, isOnline, isOfflineModeEnabled, history, loadPresentation ,loadGuestByCodeZone ]);

  if (!loaded) return <Loader />;

  return (
    <>
      {(showPresentationPage)  ?  (
        <GuestBrowsePage zone={zone} />
      ) : (
        <DocumentPinPage zone={zone} />
      )}
    </>
  );
};

export default observer(GuestLayout);
